<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Delete Confirmation!</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <p>Do you want to Delete <span style="color: var(--s-primary-color);">"{{name}}"</span> ?</p>

  <label for="" *ngIf="includesFolder" style="color: red;">Note : All files and folders inside directories will be deleted permanently.</label>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" [mat-dialog-close]='false'>No</button>
  <button type="submit" class="btn btn-primary" [mat-dialog-close]='true'>
    Yes
  </button>
</div>
